"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimParentId = exports.isObject = exports.isEmail = exports.hasKey = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./constants"), exports);
// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function hasKey(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasKey = hasKey;
function isEmail(string) {
    return EMAIL_REGEX.test(string);
}
exports.isEmail = isEmail;
function isObject(variable) {
    return variable !== null && typeof variable === 'object';
}
exports.isObject = isObject;
function trimParentId(parentChildId) {
    return typeof parentChildId === 'string' ? parentChildId.replace(/^[^_]+_/, '') : parentChildId;
}
exports.trimParentId = trimParentId;
//# sourceMappingURL=index.js.map